<template>
    <div class="content-renderer">
        <div v-for="(item, index) in content" :key="index">
            <!-- 見出し -->
            <h6 
                v-if="item.type === 'heading' && item.level <= 2" 
                :class="item.className"
            >
                <span v-html="item.text"></span>
            </h6>

            <!-- h5見出し -->
            <h5 
                v-else-if="item.type === 'heading' && item.level === 3" 
                :class="item.className"
            >
                <span v-html="item.text"></span>
            </h5>

            <!-- 段落 -->
            <p 
                v-else-if="item.type === 'paragraph'" 
                :class="item.className"
                v-html="item.text"
            ></p>

            <!-- 画像 -->
            <div 
                v-else-if="item.type === 'image'"
                :class="getImageWrapperClass(item)"
            >
                <img 
                    :src="item.src" 
                    :alt="item.alt"
                    :class="item.className"
                    :style="item.style"
                />
            </div>

            <!-- カードグリッド -->
            <div 
                v-else-if="item.type === 'card-grid'"
                :class="item.className"
            >
                <div 
                    v-for="(card, cardIndex) in item.cards" 
                    :key="cardIndex"
                    class="grid"
                >
                    <card :color="'gray'">
                        <img 
                            v-if="card.image"
                            slot="image" 
                            class="img rounded" 
                            :src="card.image" 
                        />
                        <h5 v-if="card.title" class="card-title" v-html="card.title"></h5>
                        <p v-if="card.description" class="card-description description" v-html="card.description"></p>
                    </card>
                </div>
            </div>

            <!-- リスト -->
            <ul v-else-if="item.type === 'unordered-list'" :class="item.className">
                <li v-for="(listItem, liIndex) in item.items" :key="liIndex" v-html="listItem">
                </li>
            </ul>

            <ol v-else-if="item.type === 'ordered-list'" :class="item.className">
                <li v-for="(listItem, liIndex) in item.items" :key="liIndex" v-html="listItem">
                </li>
            </ol>

            <!-- その他のHTML -->
            <div 
                v-else-if="item.type === 'html' || item.type === 'div'"
                :class="item.className"
                v-html="item.html"
            ></div>
        </div>
    </div>
</template>

<script>
import { Card } from '@/components';

export default {
    name: 'ContentRenderer',
    components: {
        Card
    },
    props: {
        content: {
            type: Array,
            required: true,
            default: () => []
        }
    },
    methods: {
        getImageWrapperClass(item) {
            // 画像のスタイルからwidthを抽出してラッパークラスを決定
            if (item.style && item.style.includes('width')) {
                const widthMatch = item.style.match(/width:\s*(\d+)%/);
                if (widthMatch) {
                    const width = parseInt(widthMatch[1]);
                    if (width <= 40) return 'col-12 col-md-4';
                    if (width <= 60) return 'col-12 col-md-6';
                    if (width <= 80) return 'col-12 col-md-8';
                }
            }
            return 'col-12';
        }
    }
};
</script>

<style scoped lang="scss">
.content-renderer {
    h5 {
        display: inline-block;
        margin: 0 auto;
        text-align: center;
        padding-bottom: 2px;
        border-bottom: 1px solid #333;
        font-weight: bold;
        font-style: italic;
    }

    .grid-container {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 1.5rem;
        margin-bottom: 2rem;
    }

    .grid-container2 {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
        gap: 1.5rem;
        margin-bottom: 2rem;
    }
}
</style>
